import { useQuery, UseQueryOptions } from 'react-query';

import { AxiosError } from 'axios';

import secAxios from '~/configs/api/axios/secAxios';
import { API_URLS } from '~/configs/api/urls';
import { CONTENTS_SERVICE_CODE } from '~/constants/TERMS';

export const STATUS = {
  신청완료: 'COMPLETE',
  신청가능: 'POSSIBLE',
  신청불가: 'IMPOSSIBLE',
  알려지지않음: 'UNKNOWN',
} as const;

export const TENDENCY = {
  없음: 'NONE',
  안전형: 'SAFETY',
  안전추구형: 'SAFETY_SEEKING',
  위험중립형: 'RISK_NEUTRAL',
  적극투자형: 'ACTIVE_INVESTMENT',
  공격투자형: 'OFFENCIVE_INVESTMENT',
  정보미제공: 'NOT_PROVIDED',
} as const;

export const SERVICE_ID = {
  콘텐츠수신동의: CONTENTS_SERVICE_CODE,
};

export type STATUS = typeof STATUS[keyof typeof STATUS];
export type TENDENCY = typeof TENDENCY[keyof typeof TENDENCY];
export type SERVICE_ID = typeof SERVICE_ID[keyof typeof SERVICE_ID];

export type ServiceInfo = {
  serviceId: SERVICE_ID;
  serviceName: string;
  status: STATUS;
  unableReasonId: string; // 불가사유코드
  unableReasonMessage: string; // 불가사유 메시지
  registeredDate: `${number}`; // 신청일자
  userTendency: TENDENCY; // 고객투자성향
  serviceTendency: TENDENCY; // 서비스투자성향
  isAllowToSuggestInvestment: boolean; // 투자권유희망 여부
};

export type ServiceInfoResponse = {
  serviceList: ServiceInfo[]; // 약정 목록
};

export const serviceInfoQueryKey = API_URLS.MEMBER.SERVICE;

type ServiceInfoParams = {
  serviceId: SERVICE_ID;
  accountKey?: string;
};

/**
 * 계좌 > 서비스 조회 확인
 * user 의 서비스 약정 상태 정보를 받아온다.
 */
const useServiceInfoQuery = (
  params: ServiceInfoParams,
  options?: UseQueryOptions<ServiceInfoResponse, AxiosError<ErrorResponse>>
) => {
  return useQuery<ServiceInfoResponse, AxiosError<ErrorResponse>>(
    serviceInfoQueryKey,
    ({ signal }) =>
      secAxios
        .get(
          `${API_URLS.MEMBER.SERVICE}/${params.accountKey}?service_id_list=${params.serviceId}`,
          { signal }
        )
        .then(({ data }) => data),
    {
      ...options,
      retry: (retryFailureCount, error) => {
        if (retryFailureCount >= 3) {
          console.error(
            `'serviceInfoQuery' API 실패 횟수 : ${retryFailureCount + 1}`
          );
          // TODO: Matrix 발송
          return false;
        }
        return true;
      },
      retryDelay: 3000,
    }
  );
};

export default useServiceInfoQuery;
